<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          Hire Monitoring - Payment Pack
        </h1>
      </template>
      <template #actions>
        <page-header-action
          :disabled="!allDocumentsApproved"
          @click.prevent="sendPaymentPack"
          v-if="!readonly"
        >
          Send Payment Pack
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <form-navigation-tabs
          :tabs="tabs"
          v-on:selected="setActive"
          :simple="true"
          :active="currentView"
        ></form-navigation-tabs>
      </div>
    </div>
    <div v-if="currentView == 'payment_pack'">
      <div class="row">
        <div class="col-lg-3">
          <div class="card mb-3">
            <div class="card-heading">
              Vehicle Hire Agreement
            </div>
            <div class="card-preview text-center">
              <transition name="component-fade">
                <div
                  class="processing-overlay"
                  v-if="!documents.vehicle_hire_agreement.generated"
                >
                  Generating Document...
                </div>
              </transition>
              <transition name="component-fade">
                <div
                  v-if="documents.vehicle_hire_agreement.approved"
                  class="approved-overlay"
                >
                  <i class="material-icons">done</i>
                </div>
              </transition>
              <img
                class="img-fluid"
                alt="Vehicle Hire Agreement"
                :src="vehicleHireAgreementThumb"
              />
            </div>
            <div class="card-controls">
              <a
                target="_blank"
                class="btn btn-block btn-dark btn-large-padding"
                :href="vehicleHireAgreementPath"
                >View Document</a
              >
              <a
                target="_blank"
                v-on:click.prevent="approveDocument('vehicle_hire_agreement')"
                class="btn btn-block btn-primary no-margin btn-large-padding"
                v-if="!readonly"
                >Approve</a
              >
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card mb-3">
            <div class="card-heading">
              Payment Request Letter
            </div>
            <div class="card-preview text-center">
              <transition name="component-fade">
                <div
                  class="processing-overlay"
                  v-if="!documents.request_for_payment.generated"
                >
                  Generating Document...
                </div>
              </transition>
              <transition name="component-fade">
                <div
                  v-if="documents.request_for_payment.approved"
                  class="approved-overlay"
                >
                  <i class="material-icons">done</i>
                </div>
              </transition>
              <img
                class="img-fluid"
                alt="Vehicle Hire Agreement"
                :src="paymentRequestLetterThumb"
              />
            </div>
            <div class="card-controls">
              <a
                target="_blank"
                class="btn btn-block btn-dark btn-large-padding"
                :href="paymentRequestLetterPath"
                >View Document</a
              >
              <a
                target="_blank"
                v-on:click.prevent="approveDocument('request_for_payment')"
                class="btn btn-block btn-primary no-margin btn-large-padding"
                v-if="!readonly"
                >Approve</a
              >
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card mb-3">
            <div class="card-heading">
              Hire Period Validation Form
            </div>
            <div class="card-preview text-center">
              <transition name="component-fade">
                <div
                  class="processing-overlay"
                  v-if="!documents.hire_period_validation.generated"
                >
                  Generating Document...
                </div>
              </transition>
              <transition name="component-fade">
                <div
                  v-if="documents.hire_period_validation.approved"
                  class="approved-overlay"
                >
                  <i class="material-icons">done</i>
                </div>
              </transition>
              <img
                class="img-fluid"
                alt="Hire Period Validation Form"
                :src="hirePeriodValidationThumb"
              />
            </div>
            <div class="card-controls">
              <a
                target="_blank"
                class="btn btn-block btn-dark btn-large-padding"
                :href="hirePeriodValidationPath"
                >View Document</a
              >
              <a
                target="_blank"
                v-on:click.prevent="approveDocument('hire_period_validation')"
                class="btn btn-block btn-primary no-margin btn-large-padding"
                v-if="!readonly"
                >Approve</a
              >
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="card mb-3">
            <div class="card-heading">
              Statement of Charges
            </div>
            <div class="card-preview text-center">
              <transition name="component-fade">
                <div
                  class="processing-overlay"
                  v-if="!documents.statement_of_charges.generated"
                >
                  Generating Document...
                </div>
              </transition>
              <transition name="component-fade">
                <div
                  v-if="documents.statement_of_charges.approved"
                  class="approved-overlay"
                >
                  <i class="material-icons">done</i>
                </div>
              </transition>
              <img
                class="img-fluid"
                alt="Vehicle Hire Agreement"
                :src="statementOfChargesThumb"
              />
            </div>
            <div class="card-controls">
              <a
                target="_blank"
                class="btn btn-block btn-dark btn-large-padding"
                :href="statementOfChargesPath"
                >View Document</a
              >
              <a
                target="_blank"
                v-on:click.prevent="approveDocument('statement_of_charges')"
                class="btn btn-block btn-primary no-margin btn-large-padding"
                v-if="!readonly"
                >Approve</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <incident-details
      :incident="incident"
      v-if="currentView == 'incident_details'"
    ></incident-details>
    <documents
      :incident="incident"
      v-if="currentView === 'documents'"
    ></documents>
  </div>
</template>

<script>
import IncidentDetails from './../Shared/IncidentDetails.vue';
import Documents from './../Shared/Documents.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'incident-details': IncidentDetails,
    documents: Documents
  },

  computed: {
    vehicleHireAgreementThumb() {
      if (this.documents.vehicle_hire_agreement.generated) {
        return `${window.AxisUK.api}incidents/${
          this.incident
        }/documents/thumb/vehicle-hire-agreement?token=${window.Token.get()}`;
      }

      return null;
    },

    vehicleHireAgreementPath() {
      if (
        this.documents.vehicle_hire_agreement.generated &&
        this.documents.vehicle_hire_agreement.hash
      ) {
        return `${window.AxisUK.storage}${this.documents.vehicle_hire_agreement.hash}`;
      }

      return null;
    },

    paymentRequestLetterThumb() {
      if (this.documents.request_for_payment.generated) {
        return (
          window.AxisUK.api +
          'incidents/' +
          this.incident +
          '/documents/thumb/payment-request-letter?token=' +
          window.Token.get()
        );
      }

      return null;
    },

    paymentRequestLetterPath() {
      if (
        this.documents.request_for_payment.generated &&
        this.documents.request_for_payment.hash
      ) {
        return `${window.AxisUK.storage}${this.documents.request_for_payment.hash}`;
      }

      return null;
    },

    hirePeriodValidationThumb() {
      if (this.documents.hire_period_validation.generated) {
        return (
          window.AxisUK.api +
          'incidents/' +
          this.incident +
          '/documents/thumb/hire-period-validation?token=' +
          window.Token.get()
        );
      }

      return null;
    },

    hirePeriodValidationPath() {
      if (
        this.documents.hire_period_validation.generated &&
        this.documents.hire_period_validation.hash
      ) {
        return `${window.AxisUK.storage}${this.documents.hire_period_validation.hash}`;
      }

      return null;
    },

    statementOfChargesThumb() {
      if (this.documents.statement_of_charges.generated) {
        return (
          window.AxisUK.api +
          'incidents/' +
          this.incident +
          '/documents/thumb/statement-of-charges?token=' +
          window.Token.get()
        );
      }

      return null;
    },

    statementOfChargesPath() {
      if (
        this.documents.statement_of_charges.generated &&
        this.documents.statement_of_charges.hash
      ) {
        return `${window.AxisUK.storage}${this.documents.statement_of_charges.hash}`;
      }

      return null;
    },

    allDocumentsApproved() {
      var status = true;

      Object.keys(this.documents).forEach((document, index) => {
        if (this.documents[document].approved === false) {
          status = false;
        }
      });

      return status;
    }
  },

  data() {
    return {
      currentView: 'payment_pack',
      documents: {
        vehicle_hire_agreement: {
          generated: false,
          approved: false
        },
        request_for_payment: {
          generated: false,
          approved: false
        },
        hire_period_validation: {
          generated: false,
          approved: false
        },
        statement_of_charges: {
          generated: false,
          approved: false
        }
      },
      tabs: [
        {
          name: 'payment_pack',
          label: 'Payment Pack'
        },
        {
          name: 'incident_details',
          label: 'Incident Details'
        },
        {
          name: 'documents',
          label: 'Documents'
        }
      ]
    };
  },

  mounted() {
    this.getDocuments();
  },

  methods: {
    getDocuments() {
      window.Ajax.get(`/incidents/${this.incident}/documents`)
        .then(response => {
          this.processDocuments(response.data);
        })
        .catch(error => {});
    },

    processDocuments(documents) {
      let itemsProcessed = 0;
      documents.forEach(document => {
        if (this.documents[document.type.name]) {
          this.documents[document.type.name].generated = true;
          this.documents[document.type.name].hash = document.hash;
        }

        itemsProcessed++;

        if (itemsProcessed === documents.length) {
          this.getRemainingDocuments();
        }
      });
    },

    getRemainingDocuments() {
      let statementOfCharges = this.getStatementOfChargesDocument();
      let paymentRequestLetter = this.getPaymentRequestLetter();
      let hirePeriodValidation = this.getHirePeriodValidationDocument();

      Promise.all([
        statementOfCharges,
        paymentRequestLetter,
        hirePeriodValidation
      ])
        .then(() => {})
        .catch(() => {});
    },

    getStatementOfChargesDocument() {
      return new Promise((resolve, reject) => {
        if (!this.documents.statement_of_charges.generated) {
          window.Ajax.post(
            '/claim-monitoring/' + this.incident + '/statement-of-charges'
          )
            .then(response => {
              this.documents.statement_of_charges.generated = true;
              this.documents.statement_of_charges.hash = response.data.hash;
              resolve();
            })
            .catch(error => {
              reject();
            });
        } else {
          resolve();
        }
      });
    },

    getPaymentRequestLetter() {
      return new Promise((resolve, reject) => {
        if (!this.documents.request_for_payment.generated) {
          window.Ajax.post(
            '/claim-monitoring/' + this.incident + '/payment-request-letter'
          )
            .then(response => {
              this.documents.request_for_payment.generated = true;
              this.documents.request_for_payment.hash = response.data.hash;
              resolve();
            })
            .catch(error => {
              reject();
            });
        } else {
          resolve();
        }
      });
    },

    getHirePeriodValidationDocument() {
      return new Promise((resolve, reject) => {
        if (!this.documents.hire_period_validation.generated) {
          window.Ajax.post(
            '/claim-monitoring/' + this.incident + '/hire-period-validation'
          )
            .then(response => {
              this.documents.hire_period_validation.generated = true;
              this.documents.hire_period_validation.hash = response.data.hash;
              resolve();
            })
            .catch(error => {
              reject();
            });
        } else {
          resolve();
        }
      });
    },

    sendPaymentPack() {
      if (this.readonly) return;
      this.route(`/claim-monitoring/${this.incident}/email`);
    },

    setActive(tab) {
      this.currentView = tab;
    },

    toggleNotes() {
      this.notes = !this.notes;
    },

    approveDocument(name) {
      if (this.readonly) return;
      this.documents[name].approved = true;
    }
  }
};
</script>
